import React from "react";
import AdminSidebar from "../components/AdminSidebar";
import AdminDashboard from "../components/AdminDashboard";
import ProfileHeader from "../components/ProfileHeader";

const AdminPage = () => {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <AdminSidebar />

      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <ProfileHeader />
        <AdminDashboard />
      </div>
    </div>
  );
};

export default AdminPage;